/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortContentCompletedVideoView.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import FormattedMessage from 'I18n/components/FormattedMessage';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import ShortContentFullToolRecommendations from '../../toolRecommendations/components/ShortsRecommendations/ShortContentFullToolRecommendations.migrated';
import { useGetToolRecommendations } from '../../toolRecommendations/hooks/softwareDiscoveryHooks.migrated';
import { useResponsiveToolDisplay } from '../../toolRecommendations/hooks/useResponsiveToolDisplay.migrated';
import { VideoRecommendationsForLearningContent } from '../../recommendations/components/VideoRecommendationsForLearningContent.migrated';

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortContentCompletedVideoView.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortContentCompletedVideoView = ({
  short,
  isInCollection = false
}) => {
  const {
    isDesktop
  } = useMediaQuery();
  const {
    contentId,
    language,
    name = '',
    useCases = []
  } = short || {};
  const toolRecommendations = useGetToolRecommendations(useCases, language ? readUnhandledEnumCase(language) : undefined);
  const toolsToDisplay = useResponsiveToolDisplay({
    collectionType: isInCollection ? 'shortPlaylist' : undefined
  });
  const shouldShowToolRecommendations = !!(isDesktop && toolRecommendations && toolsToDisplay);
  return contentId && short ? /*#__PURE__*/_jsx(VideoRecommendationsForLearningContent, {
    id: contentId,
    isInCollection: isInCollection,
    language: language,
    moreTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.shortContent.moreTitle"
    }),
    render: recommendationsContent => shouldShowToolRecommendations ? /*#__PURE__*/_jsx(ShortContentFullToolRecommendations, {
      contentLanguage: language ? readUnhandledEnumCase(language) : undefined,
      contentName: name,
      toolsToDisplay: toolsToDisplay,
      useCases: useCases
    }) : recommendationsContent,
    type: "SHORT_FORM_CONTENT"
  }) : null;
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/shortContent/components/ShortContentCompletedVideoView.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default ShortContentCompletedVideoView;